document.addEventListener("DOMContentLoaded", function () {
  const splideElem = document.querySelector(".splide-medias-reviews");

    new Splide(splideElem, {
      type: "slide",
      rewind: true,
      arrows: false,
      pagination: true,
      gap: 20,
      autoWidth: true,
      mediaQuery: "min",
      breakpoints: {
        1100: {
          destroy: true,
        },
      },
    }).mount();

});
